import { render, staticRenderFns } from "./SelectorOption.vue?vue&type=template&id=67a9d4ae&"
import script from "./SelectorOption.vue?vue&type=script&lang=js&"
export * from "./SelectorOption.vue?vue&type=script&lang=js&"
import style0 from "./SelectorOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports